import { escapeHTML } from './utils.js';

$(function() {
	// autocomplete
	var autocomplete_urls = {
		'projects' 	: '/projects/quicksearch_ajax',
		'quotes' 	: '/quotes/quicksearch'
	};

	var $input_query = $( '#q' );

	$input_query.autocomplete(autocomplete_urls[ 'projects' ], {
		delay: 250,
		scrollHeight: 800,
		dataType: 'json',
		matchSubset : false,
		minChars: 2,
		parse: function(data) {
			var res = [];
			
			for( var i = 0; i < data.length; i++ ) {
				res.push({
					data: data[i],
					value: data[i],
					result: data[i].client_name
				});
			}

			return res;
        },
		resultsClass: "ac_results main-search-results",
		formatItem: function(row) {
			// searching quotes
			if( row.quote_name !== undefined ) {
				return row.quote_name
			}

			// searching projects
			var project_slug = escapeHTML(row.token);
			if ( row.title ) {
				project_slug = escapeHTML(row.title);
			}

			return escapeHTML(row.client_name) + ' -- ' + (project_slug);
        }
	}).result(function (event, res) {
		location.href = res.permalink;
	});


	// remove the autocomplete if we're search charges/clients
	$input_query.keyup(function(){
		var $q = $( this );

		// check if we match no autocomplete search
		if( /^(charges?|c|clients?):\s*(.*)/.test( $q.val() ) ) {
			$q.setOptions({ 'url' : '' });

			return;
		}

		// we're search for quotes - use quotes autocomplete url
		if( /^(q|quotes?):\s*(.*)/.test( $q.val() ) ) {
			$q.setOptions({ 
				'url' : autocomplete_urls[ 'quotes' ],
				highlight: function(value, term) {
					term = term.replace(/^(q|quotes?)\: /, '');
					return value.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + term.replace(/([\^\$\(\)\[\]\{\}\*\.\+\?\|\\])/gi, "\\$1") + ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<strong>$1</strong>");
		        }
			});

			return;
		}

		// we're searching projects - use projects autocomplete url
		$q.setOptions({ 'url' : autocomplete_urls[ 'projects' ] });

		return;
	});
	
});
